<template>
  <div id="sw" />
</template>

<script>
import { useToast } from "vue-toastification";
import ToastComponent from "@/components/ToastComponent";
export default {
  setup() {
      const toast = useToast();
      return { toast }
    },
  mounted() {
    document.addEventListener("swUpdated", this.showToast);
  },
  beforeUnmount() {
    document.removeEventListener("swUpdated", this.showToast);
  },
  methods: {
    showToast() {
      this.toast({
          component: ToastComponent,

          props: {
              text: this.$t("please_reopen_the_page"),
              action: () => {
                this.reloadPage();
              },
              actionName: this.$t("refresh"),
              
              closeText: this.$t("close"),
            },

            }, { containerClassName: "my-container-class", toastClassName: "my-custom-toast-class", bodyClassName: ["custom-class-1"], })
    },
    reloadPage() {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    }
  }
};
</script>
<style></style>
